// extracted by mini-css-extract-plugin
module.exports = {"title":"member-operations__ResetForm__title","description":"member-operations__ResetForm__description","buttons":"member-operations__ResetForm__buttons"};